import {
  ILoginUserData,
  ILoginResponse,
  ILoginByTokenResponse,
  ILoginByTokenData,
  ILoginByGoogleResponse,
  OldLoginInfo,
  ILoginMobileSSOResponse,
} from '../../login/dto/login-response.interface';

export class AuthMobileModel {
  authorization_code!: string | undefined;
  redirect_uri!: string | undefined;

  mapDataFromAPI(args: ILoginMobileSSOResponse) {
    this.authorization_code = args?.authorization_code ?? '';
    this.redirect_uri = args?.redirect_uri ?? '';
    return this;
  }
}
